import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import DetailsList from '../../../../../../common/details-list';
import locales from '../../../../../../../constants/locales';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationSuccess } from './interfaces';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, customerMsisdn } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.customerMsisdn,
              value: detailsValueFormatter(customerMsisdn)
            },
            { label: locales.operation.label.customerEmail, value: details.customerEmail },
            { label: locales.operation.label.productId, value: details.productId },
            {
              label: locales.operation.label.acquirerMsisdn,
              value: detailsValueFormatter(details.acquirerMsisdn)
            }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
